import { ChangeEventHandler, FC } from "react";
import styled from "styled-components";
import { SearchIcon } from "../Icons";

const InputField = styled.input`
	width: 100%;
	justify-content: flex-start;
	align-items: center;
	align-content: stretch;
	background: #ffffff;
	border: 0px;
	margin-left: 10px;
	font-family: Livvic;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 165.5%;
	:focus {
		outline: none;
	}
	::placeholder {
		color: #959aab;
	}
`;

const InputWrapper = styled.div`
	height: 42px;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: center;
	align-content: stretch;
	background: #ffffff;
	box-shadow: 0px 4px 39px 6px rgba(0, 0, 0, 0.07);
	border-radius: 8px;
	padding-left: 10px;
`;

interface ISearchField {
	placeholder?: string;
	onChange?: ChangeEventHandler<HTMLInputElement>;
	value?: string;
	inputRef?: ((instance: HTMLInputElement | null) => void) | React.RefObject<HTMLInputElement> | null | undefined;
}

const SearchField: FC<ISearchField> = props => {
	return (
		<InputWrapper>
			<SearchIcon color="#000000" size={20} />
			<InputField {...props} ref={props.inputRef} />
		</InputWrapper>
	);
};

export default SearchField;
